"use client"
import PropTypes from "prop-types"

const Progress = ({ minimum = 0, maximum = 9, step = 1, currentVal = 0, description = "", onChange = () => {} }) => {
  const massive = [...Array((1 / step) * (maximum - minimum) + 1)].map(
    (el, index) => Math.round((minimum + index * step) * 10) / 10,
  )

  return (
    <div className="numbers">
      <div className="description">{description}</div>
      <span
        className={`number${currentVal === minimum ? " disabled" : ""}`}
        onClick={() => {
          if (currentVal > minimum) {
            onChange(Math.round((currentVal - step) * 10) / 10)
          }
        }}
      >
        -
      </span>
      {massive.map((num) => (
        <span
          key={num}
          title={`${num}`}
          className={"item " + (num === currentVal ? "selected" : "")}
          onClick={() => onChange(num)}
        >
          &#160;
        </span>
      ))}
      <span
        className={`number${currentVal === maximum ? " disabled" : ""}`}
        onClick={() => {
          if (currentVal < maximum) {
            onChange(Math.round((currentVal + step) * 10) / 10)
          }
        }}
      >
        +
      </span>
    </div>
  )
}

Progress.propTypes = {
  minimum: PropTypes.number,
  step: PropTypes.number,
  maximum: PropTypes.number,
  currentVal: PropTypes.number,
  description: PropTypes.string,
  onChange: PropTypes.func,
}

export default Progress
